import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { plPL, enUS, deDE } from '@mui/x-date-pickers/locales';

interface Props {
  id: string;
  label: string;
  value: string;
  minDate: string;
  maxDate: string;
  disabled?: boolean;
  describedBy: string;
  onChange: (value: string) => void;
}

export function BookingDateField({ id, label, value, minDate, maxDate, disabled, describedBy, onChange }: Props) {
  const { i18n } = useTranslation();
  const locale = i18n.language.split('-')[0];
  const localeText = (locale === 'de' ? deDE : locale === 'en' ? enUS : plPL)
    .components.MuiLocalizationProvider.defaultProps.localeText;

  return (
    <div className="booking-field booking-date-field">
      <label htmlFor={id}>{label}</label>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale} localeText={localeText}>
        <DatePicker
          format="DD/MM/YYYY"
          enableAccessibleFieldDOMStructure={false}
          value={value ? dayjs(value, 'YYYY-MM-DD', true) : null}
          minDate={minDate && dayjs(minDate, 'YYYY-MM-DD', true).isValid() ? dayjs(minDate) : undefined}
          maxDate={maxDate ? dayjs(maxDate) : undefined}
          disabled={disabled}
          reduceAnimations
          onChange={date => onChange(date === null ? '' : date.isValid() ? date.format('YYYY-MM-DD') : 'invalid')}
          slotProps={{
            openPickerButton: { edge: false },
            textField: {
              id, fullWidth: true, size: 'small',
              inputProps: { 'aria-describedby': describedBy, placeholder: 'DD/MM/YYYY' },
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
}
